import * as S from "effect-app/Schema"
import { NonEmptyString255 } from "effect-app/Schema"
import { type HasTimestamps, TimestampProps } from "./Timestamps.ts"

export const RALColorId = S.StringId
export type RALColorId = S.StringId

export const RALColorValue = NonEmptyString255 // TODO
export type RALColorValue = NonEmptyString255

export class RALColor extends S.Opaque<RALColor, RALColor.Encoded>()(
  S
    .Struct({
      id: RALColorId.withConstructorDefault,
      name: S.NonEmptyString255,
      value: S.NonNegativeInt,
      color: RALColorValue,
      isEnabled: S.Boolean.withConstructorDefault,
      ...TimestampProps
    })
    .annotate({ identifier: "RALColor" })
) implements HasTimestamps {}

// codegen:start {preset: model}
//
export namespace RALColor {
  export interface Encoded extends S.StructNestedEncoded<typeof RALColor> {}
}
//
// codegen:end
//
